import React from 'react';
import { observer } from 'mobx-react';
import C3Chart from 'react-c3js';
import { withStyles } from '@material-ui/core';

import Panel from '../../commons/Panel';
import Cadeiras from './Cadeiras';
import Candidatos from '../distribuicao/Candidatos';
import EvolucaoDialog from '../../commons/EvolucaoDialog';

import EvolucaoStore from '../../../stores/EvolucaoStore';
import SelecaoStore from '../../../stores/SelecaoStore';
import UIStore from '../../../stores/UIStore';

const styles = theme => ({
  top: {
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  chart: {
    [theme.breakpoints.up('md')]: {
      padding: '16px',
      width: '60%',
      marginRight: '10px',
      borderRight: '1px solid lightgrey',
    },
  },
  chairs: {
    [theme.breakpoints.up('md')]: { width: '30%', marginLeft: '10px' },
  },
});

class Vagas extends React.Component {
  state = { vagas: 0 };

  componentWillMount() {
    UIStore.init(
      'Gráfico de Vagas',
      null,
      null,
      false,
      SelecaoStore.loadColigacoes
    );
    SelecaoStore.candidatos = [];
    SelecaoStore.loadColigacoes();
  }

  render() {
    let { classes } = this.props;

    let vagas = {
      type: 'bar',
      labels: true,
      x: 'coligacao',
      columns: [
        ['coligacao', ...SelecaoStore.coligacoes.map(c => [c.coligacao.nome])],
        [
          'total',
          ...SelecaoStore.coligacoes.map(c => [c.vagasDiretas + c.vagasSobras]),
        ],
      ],
      color: (color, d) =>
        d.x >= 0 ? SelecaoStore.coligacoes[d.x].coligacao.cor : '#888',
      onclick: e => {
        this.setState({ vagas: e.value });
        SelecaoStore.selecionarCandidatos(
          SelecaoStore.coligacoes[e.index].coligacao
        );
      },
    };

    return (
      <React.Fragment>
        <Panel
          title="Projeção"
          noSpacing
          loadHistory={() => EvolucaoStore.loadColigacoes()}
        >
          <div className={classes.top}>
            <div className={classes.chart}>
              <C3Chart
                style={{ height: '520px', maxHeight: '520px' }}
                data={vagas}
                axis={{ rotated: true, x: { type: 'category' } }}
                legend={{ show: false }}
              />
            </div>
            <Cadeiras className={classes.chairs} />
          </div>
          <Candidatos vagas={this.state.vagas} />
        </Panel>
        <EvolucaoDialog
          title="Evolução das Vagas"
          opened={EvolucaoStore.coligacoes != null}
          data={EvolucaoStore.coligacoes}
          onOK={() => (EvolucaoStore.coligacoes = null)}
        />
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(observer(Vagas));



// WEBPACK FOOTER //
// ./src/components/proporcional/vagas/index.js